import React from 'react';
import ReactDOM from 'react-dom';

import './App.css';

import App from './App';
import * as serviceWorker from './serviceWorker';

// Remove console.log
console.log = () => {}
console.error = () => {}
console.debug = () => {}

ReactDOM.render(<App />, document.getElementById('root'));

serviceWorker.register();